<template>
    <div class="envio" :class="getEstado(envio.est_id)" :style="getTamano()" :id="id" @click="verEnvio()">
        <div class="envio-container">
            <div class="cliente">{{ envio.cli_nombre }}</div>
            <template v-if="height > 80">
                <div class="data">
                    <span class="nj-bold nj-text-right">envio:</span>
                    <span class="nj-text-left">{{ envio.env_codigo }}</span>
                    <span class="nj-bold nj-text-right">ubicación:</span>
                    <span class="nj-text-left"> {{ envio.ubi_nombre }}</span>
                    <span class="nj-bold nj-text-right">volúmen:</span>
                    <span class="nj-text-left"> {{ envio.env_cantidad }} m3</span>
                    <span class="nj-bold nj-text-right">tiempo:</span>
                    <span class="nj-text-left"> {{ getTime(envio.env_fecha_hora_carguio) }}-{{ getTime(envio.env_fecha_hora_retorno) }}</span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Arrays from "../../util/arrays"
import DateTime from "../../util/dateTime"
import { EnvioEvent, EnvioEventTypes } from "../../util/events"

export default {
    name: "EnvioItem",
    props: {
        id: {
            type: String
        },
    },
    components: {

    },
    data() {
        return {
            envio: null,
            offset: null,
            estados: [],
            height: null,
            show: false
        }
    },
    methods: {
        getTamano() {
            // definiendo las dimensiones del envio en el calendario
            const t1 = DateTime.buildDate2(this.envio.env_fecha_hora_carguio).getTime() / (1000 * 60)
            const t2 = DateTime.buildDate2(this.envio.env_fecha_hora_retorno).getTime() / (1000 * 60)
            // aplicando las dimensiones usando css
            this.height = t2 - t1
            return {
                height: `${(this.height)}px`,
                transform: `translate(0, ${this.offset}px)`
            }
        },
        getEstado(estId) {
            // definiendo el color del estado del envio
            const estado = Arrays.find(this.estados, "est_id", estId)
            return estado ? estado.styles : ""
        },
        getTime(time) {
            // obteniendo el tiempo para usarlo como referencia en el calendario
            const aux = DateTime.convertStringToObject(time)
            return aux.hour + ":" + aux.min
        },
        verEnvio() {
            EnvioEvent.$emit(EnvioEventTypes.verEnvio, this.envio)
        }

    },
    mounted() {

    }
}
</script>

<style scoped>
.envio {
    display: flex;
    align-items: start;
    justify-content: center;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    border-radius: 4px;
    padding: 8px;
    width: 100%;
    height: 1px;
    cursor: pointer;
    overflow: hidden;
    opacity: .70;
    --time: .2s;
    transition: margin var(--time) ease-in-out, opacity var(--time);
}

.envio:hover {
    z-index: 12;
    opacity: 1;
    margin-left: -5px;
    transition: margin var(--time) ease-in-out, opacity var(--time);
}

.envio-container {
    width: 100%;
    overflow: hidden;
}

.cliente {
    font-size: 14px;
    margin: 0 0 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.data {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
}

.distrito,
.codigo,
.cantidad,
.rango {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>